import Swiper from "swiper";
import { A11y, Navigation, Pagination } from "swiper/modules";
import $ from "jquery";

const areaSwiper = (el) => {
    let $el = $(el);

    if ($el.length === 0) {
        throw new Error(
            "Element not found for Swiper initialization [areaSwiper]"
        );
    }

    new Swiper(".js-area-card-swiper", {
        modules: [Navigation, Pagination, A11y],
        slidesPerView: 1.2,
        slidesPerGroup: 1,
        spaceBetween: 24,
        edgeSwipeDetection: true,
        navigation: {
            nextEl: ".area-swiper__button-next",
            prevEl: ".area-swiper__button-prev",
        },
        rewind: true,
        breakpoints: {
            320: {
                slidesPerView: 1.2,
                slidesPerGroup: 1,
            },
            480: {
                slidesPerView: 1.4,
                slidesPerGroup: 1,
            },
            768: {
                slidesPerView: 2.1,
                slidesPerGroup: 2,
            },
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        },
        pagination: {
            el: ".area-swiper__pagination",
            type: "bullets",
            clickable: true,
        },
        on: {
            slideChange: function () {
                let currentSlide = this.realIndex;
                let activeSlideView;

                const windowWidth = $(window).width();

                switch (true) {
                    case windowWidth < 480:
                        activeSlideView = Math.ceil(currentSlide + 1);
                        break;
                    case windowWidth < 768:
                        activeSlideView = Math.ceil(currentSlide + 1);
                        break;
                    case windowWidth < 1024:
                        activeSlideView = Math.ceil(currentSlide / 2);
                        break;
                    default:
                        activeSlideView = Math.ceil(currentSlide / 2);
                        break;
                }

                document.querySelector(
                    ".area-swiper .current-slide"
                ).innerHTML = activeSlideView;
            },
            afterInit: function () {
                let numOfSlides = this.pagination.bullets.length;
                document.querySelector(".area-swiper .total-slides").innerHTML =
                    numOfSlides;
                if (numOfSlides > 10) {
                    document.querySelector(
                        ".area-swiper .swiper-pagination"
                    ).style.display = "none";
                } else {
                    document.querySelector(
                        ".area-swiper .swiper-pagination"
                    ).style.display = "flex";
                }
            },
            resize: function () {
                let numOfSlides = this.pagination.bullets.length;
                document.querySelector(".area-swiper .total-slides").innerHTML =
                    numOfSlides;

                if (numOfSlides > 10) {
                    document.querySelector(
                        ".area-swiper .swiper-pagination"
                    ).style.display = "none";
                } else {
                    document.querySelector(
                        ".area-swiper .swiper-pagination"
                    ).style.display = "flex";
                }
            },
        },
    });
};

export default areaSwiper;
